var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19064 13.1667C2.61268 13.1667 1.3335 11.9025 1.3335 10.3431C1.3335 8.78374 2.61268 7.51961 4.19064 7.51961C4.38005 7.51961 4.56516 7.53782 4.74427 7.57258M9.58746 5.85147C9.98464 5.71274 10.4121 5.63726 10.8573 5.63726C11.2938 5.63726 11.7131 5.70979 12.1036 5.84332M4.74427 7.57258C4.59154 7.1652 4.5081 6.72458 4.5081 6.26471C4.5081 4.18552 6.21368 2.5 8.31762 2.5C10.2774 2.5 11.8916 3.96247 12.1036 5.84332M4.74427 7.57258C5.12055 7.64559 5.47035 7.7916 5.77794 7.99507M12.1036 5.84332C13.5955 6.35349 14.6668 7.75408 14.6668 9.40196C14.6668 11.2066 13.3819 12.7147 11.6668 13.0815",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 11.1666V15.1666M7.99984 11.1666L9.33317 12.5M7.99984 11.1666L6.6665 12.5",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/CloudUpload.6a9e551f4174a03e361d66bed08c7255.svg";
export { ForwardRef as ReactComponent };